<template>
  <q-drawer
    v-if="!rerender"
    v-bind="$props"
    class="page-drawer"
    @update:model-value="(val) => $emit('update:modelValue', val)"
  >
    <slot />
  </q-drawer>
</template>

<script>
/**
 * Overrides default QDrawer and ties in with the PageLayout and maintaining
 * drawer states
 *
 * PageDrawer is the drawer which can be rendered onto the right side of the screen
 *
 * Props are from QDrawer.
 *
 * SLOTS:
 * - default: content to display in drawer
 */
export default {
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    side: {
      type: String,
      default: 'right'
    },
    persistent: {
      type: Boolean,
      default: true
    },
    breakpoint: {
      type: Number,
      default: 1030
    },
    showIfAbove: {
      type: Boolean,
      default: true
    },
    width: {
      type: Number
    }
  },
  emits: ['update:modelValue'],
  data () {
    return {
      rerender: false
    }
  },
  methods: {
    busRecheckWindow () {
      this.rerender = true
      this.$nextTick(() => {
        this.rerender = false
      })
    }
  },
  created () {
    this.$bus.on('layout:get', this.busRecheckWindow)
  },
  beforeUnmount () {
    this.$bus.off('layout:get', this.busRecheckWindow)
  }
}
</script>
